import Pagination from '../Pagination/index';

export default {
    depthChart: null,
    error: '',
};
